import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

import { BoldText } from "./BoldText";

export const PageTitle = ({
    children,
    className,
    as = "h1",
    ...props
}: ComponentProps<typeof BoldText>) => {
    return (
        <BoldText as={as} className={cn("mb-6", className)} {...props}>
            {children}
        </BoldText>
    );
};
